import { FaroLogger } from './FaroLogger';
import { LoggerPort } from './LoggerPort';

/**
 * Композиционный корень логирования: единственное место, где выбирается
 * реализация порта. Экраны и хуки импортируют собранный экземпляр отсюда,
 * а тест подменяет модуль целиком и получает свой логгер.
 */
export const logger: LoggerPort = new FaroLogger();
